import React from 'react'
import PropTypes from 'prop-types'
import { DurationInput, getColor, mergeProps } from 'labguard-cdk'
import styles from './ThresholdDurationInput.scss'

const ThresholdDurationInput = ({ color, ...domProps }) => (
  <DurationInput {...mergeProps()({ className: styles.input, style: { color: getColor(color) } }, domProps)} />
)

ThresholdDurationInput.defaultProps = {
  color: 'dark',
}

ThresholdDurationInput.propTypes = {
  ...DurationInput.propTypes,
  color: PropTypes.string,
}

export default ThresholdDurationInput
